import React from 'react';
import PropTypes from 'prop-types';

import PublicationCard from 'components/cards/entities/PublicationCard';
import SimilarEntities from 'components/sections/SimilarEntities';

import { PublicationType } from 'propTypes/entities';

const SectionSimilarEntities = ({ entities }) => (
	<SimilarEntities
		Card={PublicationCard}
		cardParams={{
			params: { width: 392, height: 282 },
			typeWidth: 'fluidLandscapeSlide'
		}}
		entities={entities}
	/>
);

SectionSimilarEntities.propTypes = {
	entities: PropTypes.arrayOf(PublicationType).isRequired
};

export default SectionSimilarEntities;
